import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"

//Import sections
import RoleList from "./RoleList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const RoleView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Roles | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Roles" breadcrumbItem="Manage Roles" />
          <Row>
            <Col lg="12">
              <RoleList />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

RoleView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(RoleView)
